import React, { useMemo } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import PropTypes from 'prop-types';

import { Icon, IconSize, IconType } from '../Utils';

import * as s from './WireframeThumbnail.module.scss';

const sanitizeSvg = (svg) =>
  DOMPurify.sanitize(svg, {
    USE_PROFILES: { svg: true, svgFilters: true },
    ADD_TAGS: ['foreignObject'],
  });

const WireframeThumbnail = React.memo(({ thumbnailSvg }) => {
  const cleanSvg = useMemo(() => (thumbnailSvg ? sanitizeSvg(thumbnailSvg) : null), [thumbnailSvg]);

  if (!cleanSvg) {
    return (
      <div className={s.placeholder}>
        <Icon type={IconType.PencilRuler} size={IconSize.Size20} />
      </div>
    );
  }

  // eslint-disable-next-line react/no-danger
  return <div className={s.thumbnail} dangerouslySetInnerHTML={{ __html: cleanSvg }} />;
});

WireframeThumbnail.propTypes = {
  thumbnailSvg: PropTypes.string,
};

WireframeThumbnail.defaultProps = {
  thumbnailSvg: undefined,
};

export default WireframeThumbnail;
